<script lang="ts">
export default {
  name: 'KkIndexCard',
}
</script>
<script setup lang="ts">
import type { Benefit } from '../../../../new_stores/pages/benefits/modules'

type Props = {
  benefit: Benefit
}
const props = defineProps<Props>()

</script>
<template>
  <div class="indexCard">
    <img class="indexCard__image" :src="props.benefit.eyeCatchUrl" alt="">
    <div class="indexCard__info">
      <p class="indexCard__info__title">{{ props.benefit.title }}</p>
      <p class="indexCard__info__content">{{ props.benefit.content.title }}</p>
    </div>
    <div class="indexCard__service">
      <img class="indexCard__service__image" :src="props.benefit.service.iconUrl" alt="">
      <p class="indexCard__service__name">{{ props.benefit.service.name }}</p>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/var';
.indexCard {
  border: solid 1px #E3E3E3;
  border-radius: 12px;
  padding: 0px 0px 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  &__image {
    width: 100%;
    object-fit: cover;
    flex: 1;
  }
  &__info {
    padding: 10px 16px 18px 16px;
    &__title {
      font-size: 16px;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      height: 55px; //カード全体の高さを固定したいので2列の時の高さを設定している
      margin-bottom: 5px;
    }
    &__content {
      font-size: 14px;
      font-weight: bold;
      color: $color-accent-primary;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      height: 72px; //カード全体の高さを固定したいので3列の時の高さを設定している
    }
  }
  &__service {
    display: flex;
    align-items: center;
    padding: 0 16px;
    &__image {
      height: 32px;
      width: 32px;
      border-radius: 4px;
    }
    &__name {
      margin-left: 8px;
      font-size: 10px;
    }
  }
}
</style>
